import React from 'react'
import moment from 'moment'
import BarcodeCom from './BarcodeCom'
import CDCSList from './CDCSList'
import Footer from '../controls/Footer'
import SafeImage, { SIGNATURE_PLACEHOLDER } from '../controls/SafeImage'
class ShowPrint extends React.Component {

  constructor(props){
    super(props)
  }
  
 

render(props) {
     const record= this.props.record
     const classes = this.props.classes
     return(
        <div className={classes.root}>
          <table className={classes.tableOuter}>
          <tbody>
            <tr>
              <td>
            
            <div className={classes.title}>DONOR IDENTIFICATION CARD</div>
           
            <table className={classes.tableNoBorder}>
            <tbody>
              <tr>
                <td colSpan="6" align="center">
                  {(record && record.photo_url)?
                  <img src={record ? `${record.photo_url}` : ''} alt="" className={classes.imgPrint} />
                  : ''}
                </td>
              </tr>
            </tbody>
            </table>
            <table className={classes.tableNoBorder} border='1'>
            <tbody>
              <tr>
                <th>DATE</th>
                <td>{moment(record.created_date).format('MM/DD/YYYY')}</td>
                <th>DONOR#</th>
                <td>{record.ssn}</td>
                <th>QA INITIALS/ DATE</th>
                <td></td>
              </tr>
              <tr>
                <th>NAME</th>
                <td colSpan='3'>{record.last_name + ',  ' + record.first_name + '  ' + ((record && record.middle_name )?  record.middle_name : '' )}</td>
                <th>GENDER</th>
                <td>{record.gender}</td>
              </tr>
              <tr>
                <th>ADDRESS</th>
                <td colSpan='3'>{record ? `${((record.apt)? record.apt: '' ) 
                                + '  ' + record.street + ',  ' + ((record.city)? record.city: '' ) + '   ' + ((record.zip)? record.zip: '' )  + ' '  
                                +((record.state)? record.state: '' )}` : ''} 
                </td>
                <th>QA INITIALS/ DATE</th>
                <td></td>
              </tr>
              <tr>
                <th>NDDR TRANSACTION#</th>
                <td colSpan='3'>&nbsp;</td>
                <th>PHONE</th>
                <td>{record ? `${record.don_ph}` : ''}</td>
              </tr>
              <tr>
                <th>SSN or BCC</th>
                <td colSpan='3'> <BarcodeCom value={record ? `${record.ssn}` : ''} /></td>
                <th>DATE OF BIRTH</th>
                <td>{record ? `${moment(record.dob).format('MM/DD/YYYY')}` : ''}</td>
              </tr>
              <tr>
                <th>ALLERGIES</th>
                <td colSpan='5'>{record ? ((record.allergies)? record.allergies: '' ): '' }
                </td>
              </tr>
             </tbody>
            </table>
            <table  className={classes.tableNoBorder} >
              <tbody>
                    <tr>
                      <td colSpan='3'>&nbsp;</td>
                    </tr>
                    <tr>
                      <th >DONOR SIGNATURE:</th>
                      <td  width="60%" className={classes.tdline}>{record ? <SafeImage src={record.donor_signature} fallbackSrc={SIGNATURE_PLACEHOLDER} alt="Donor signature" className={classes.sign} /> : '' }</td>
                      <th>DATE</th>
                      <td width="15%" className={classes.tdline}> </td>
                    </tr>
                    <tr>
                      <th>Tech. Initial & Date:</th>
                      <td colSpan='3'>
                        <table  className={classes.tableNoBorder}>
                        <tbody>
                          <tr>
                              <td className={classes.tdline}  width="30%" ></td>
                              <th>QA Initial & Date:</th>
                              <td className={classes.tdline}  width="30%"> </td>
                          </tr>
                        </tbody>
                        </table>
                      </td>
                     
                    </tr>
                    <tr>
                      <td colSpan='4'><CDCSList ssn={record.ssn} classes={this.props.classes}/></td>
                    </tr>
               </tbody>
            </table>
            
            <br />
            <table  className={classes.tableNoBorder} >
              <tbody>
                <tr>
                  <td>Card Reprint: Yes(circle) Date:</td><td width="7%"></td><td>Initials:</td><td width="7%"></td><td>Information transfer: Yes (circle) Date:</td><td width="7%"></td><td>Initial:</td><td width="7%"></td>
                </tr>
                <tr>
                  <td colSpan="8">&nbsp;</td>
                </tr>
                <tr>
                  <td>DONOR RECORD FILE ARCHIVED:</td><td width="7%"></td><td>Chart Number:</td><td width="7%"></td><td>Tech initials / Date:</td><td width="7%"></td><td>QA initial / Date:</td><td width="7%"></td>
                </tr>
              </tbody>
            </table>
            
      
        </td>
        </tr>
        </tbody>
      </table>
      <Footer>
        <span>Edonorsoft SOP Form 02.00.06, Effective 10-05-18</span>
      </Footer>
    </div>
     )
    }
}

export default ShowPrint